import { render } from "./CreateNewRequest.vue?vue&type=template&id=ba96168a&scoped=true"
import script from "./CreateNewRequest.vue?vue&type=script&lang=js"
export * from "./CreateNewRequest.vue?vue&type=script&lang=js"

import "./CreateNewRequest.vue?vue&type=style&index=0&id=ba96168a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba96168a"]])

export default __exports__